import * as React from "react"

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 250 250" {...props}>
      <defs>
        <linearGradient
          id="prefix__a"
          x1={46.31}
          y1={145.19}
          x2={152.66}
          y2={38.83}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#8d1b11" />
          <stop offset={1} stopColor="#e93323" />
        </linearGradient>
      </defs>
      <path
        d="M28 105.35v-25.1s.05-60 68-60 68 60 68 60v19.1m0 13.9s.25 47-44 47m-80-83.9h0a12 12 0 0112 12v23.9a12 12 0 01-12 12h0a12 12 0 01-12-12v-23.9a12 12 0 0112-12zm80 83.9h0a12 12 0 01-12 12H84a12 12 0 01-12-12h0a12 12 0 0112-12h24a12 12 0 0112 12zm32-83.9h0a12 12 0 0112 12v23.9a12 12 0 01-12 12h0a12 12 0 01-12-12v-23.9a12 12 0 0112-12z"
        fill="none"
        strokeMiterlimit={10}
        strokeWidth={8}
        stroke="url(#prefix__a)"
        data-name="consultant"
      />
    </svg>
  )
}

export default SvgComponent
